import React from "react";
import {useSelector} from "react-redux";
import {Icon} from "antd";
import {addCommasToAndRoundNumbers, replaceUnderscoresWithSpaces} from "../utils";

import DataManager from '../DataManagers/DataManager'
import {fieldValueIsALink, isARuralDefinition} from "../utilsData";
import {
	isRural,
	selectedRuralDefinitionSelector
} from "../Redux/selectors";
import {getRuralOptionsColumnName} from "../Redux/Actions/utilsMapboxLayerPaint";


export const LinkWithIcon = ({href, children, showLinkIcon = true}) => {
	let _href = href.toLowerCase().startsWith('http') ? href : `http://${href}`
	return (
		<a type="link" href={_href} target="_blank" rel="noopener noreferrer">
			{children || 'Link'} {showLinkIcon && <Icon type="link" />}
		</a>
	)
}

const formatFieldName = (fieldName, fieldValue) => {
	// If a link, _fieldValue is blank, fieldName is a link
	if (fieldValueIsALink(fieldValue)) {
		return {
			_fieldName: (
				<LinkWithIcon href={fieldValue}>{fieldName}</LinkWithIcon>
			),
			_fieldValue: '',
			displayValue: false
		}
	} else {
		return {
			_fieldName: `${replaceUnderscoresWithSpaces(fieldName)}: `,
			_fieldValue: addCommasToAndRoundNumbers(fieldValue)
		}
	}
}

const MapHoverTooltipLayerField = ({fieldName, fieldValue}) => {
	const {_fieldName, _fieldValue, displayValue = true } = formatFieldName(fieldName, fieldValue)
	return (
		<div className={'tooltip-layer-field'}>
			<div className={'tooltip-field-name'}>
				{_fieldName}
			</div>
			{displayValue && <div className={'tooltip-field-value'}>
				{_fieldValue}
			</div>}
		</div>
	)
}

export const IconImage = ({iconFileName, atlLabel}) => (
	<img className="map-icon-image" src={'cori-icons/' + iconFileName + '.png'} alt={atlLabel} />
)

const TooltipLayerPolygonFillRect = ({polygonDataFillColor}) => (
	<div className="tooltip-layer-polygon-fill-rect" style={{backgroundColor: polygonDataFillColor}}/>
)

const TooltipRuralDefinition = ({layerId, feature}) => {
	const selectedRuralDefinition = useSelector(selectedRuralDefinitionSelector)
	
	const ruralFilterOptionString = feature.properties[getRuralOptionsColumnName(layerId)]
	const regionIsRural = isRural(selectedRuralDefinition, ruralFilterOptionString)
	return `Is ${regionIsRural ? '' : 'not'} rural per ${DataManager.getLayerDisplayName(layerId)}`
}

const TooltipLayerTitle = ({layerId, feature}) => {
	if (isARuralDefinition(layerId)) {
		return (
			<TooltipRuralDefinition layerId={layerId} feature={feature}/>
		)
	}
	
	const layerLabelFieldIfAny = DataManager.getLayerLabelFieldIfAny(layerId)
	return (layerLabelFieldIfAny && feature.properties[layerLabelFieldIfAny]) || DataManager.getLayerDisplayName(layerId)
}

export const MapHoverTooltipLayer = ({feature}) => {
	const { id } = feature.layer
	const fieldsToDisplayInHoverTooltip = DataManager.getFieldsToDisplayInHoverTooltip(id)
	const pointDataIcon = DataManager.getPointDataIconIfAny(id)
	const polygonDataFillColor = DataManager.getPolygonDataFillColorIfAny(id)
	
	return (
		<div className="tooltip-layer-container">
			<div className="tooltip-layer-title">
				{pointDataIcon && <IconImage iconFileName={pointDataIcon} atlLabel={id}/>}
				{polygonDataFillColor && <TooltipLayerPolygonFillRect polygonDataFillColor={polygonDataFillColor} />}
				<TooltipLayerTitle layerId={id} feature={feature}/>
			</div>
			{
				Object.keys(feature.properties)
					.reduce((layerFieldComponents, fieldName, index) => {
							const fieldToDisplay = fieldsToDisplayInHoverTooltip.find(fieldToDisplay => fieldToDisplay.fieldName === fieldName)
							if (fieldToDisplay) {
								const displayName = fieldToDisplay.displayName
								return [
									...layerFieldComponents,
									(<MapHoverTooltipLayerField
										key={index}
										fieldName={displayName}
										fieldValue={feature.properties[fieldName]}
									/>)
								]
							}
							return layerFieldComponents
						}, [])
			}
		</div>
	)
}
